import { render, staticRenderFns } from "./PetraantiquaLogo.vue?vue&type=template&id=4168f09d&scoped=true&"
var script = {}
import style0 from "./PetraantiquaLogo.vue?vue&type=style&index=0&id=4168f09d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168f09d",
  null
  
)

export default component.exports